<template>
  <div class="detailBox">
    <ul class="sBox" style="display: flex; align-items: center; gap: 16px; margin-bottom: 12px; flex-wrap: wrap;">
      <el-date-picker v-model="state.beginDate" type="date" placeholder="开始日期" value-format="YYYY-MM-DD"
        style="width: 180px" />
      <span>至</span>
      <el-date-picker v-model="state.endDate" type="date" placeholder="结束日期" value-format="YYYY-MM-DD"
        style="width: 180px" />
      <span style="margin-left: 16px">时段名</span>
      <el-input v-model="state.shiDuanMc" placeholder="如：上午场" style="width: 120px" />
      <span>开始</span>
      <el-time-picker v-model="state.kssj" format="HH:mm" value-format="HH:mm" placeholder="开始" style="width: 120px" />
      <span>结束</span>
      <el-time-picker v-model="state.jzsj" format="HH:mm" value-format="HH:mm" placeholder="结束" style="width: 120px" />
      <span>库存</span>
      <el-input-number v-model="state.batchKc" :min="0" style="width: 120px" controls-position="right" />
      <el-button type="primary" @click="onBatchSet">批量设置</el-button>
    </ul>
    <ul class="detailContent" style="flex-wrap: wrap; max-width: 900px">
      <el-table :data="state.tableData" v-loading="!Array.isArray(state.tableData)" max-height="500"
        element-loading-background="rgba(0, 0, 0, 0.2)">
        <el-table-column label="#" width="50" type="index" align="center" />
        <el-table-column prop="RiQi" label="日期" width="110" align="center">
          <template #default="{ row }">{{ formatDate(row.RiQi) }}</template>
        </el-table-column>
        <el-table-column prop="ShiDuanMc" label="时段名称" min-width="120" />
        <el-table-column label="开始时间" width="90" align="center">
          <template #default="{ row }">{{ formatTime(row.Kssj) }}</template>
        </el-table-column>
        <el-table-column label="结束时间" width="90" align="center">
          <template #default="{ row }">{{ formatTime(row.Jzsj) }}</template>
        </el-table-column>
        <el-table-column prop="Zkc" label="总库存" width="90" align="center" :formatter="$tab_NumberFormat" />
        <el-table-column prop="Yssl" label="已售" width="70" align="center" :formatter="$tab_NumberFormat" />
        <el-table-column prop="Sykc" label="剩余" width="70" align="center" :formatter="$tab_NumberFormat" />
        <el-table-column label="操作" width="70" align="center" className="tabBtn">
          <template #default="{ row }">
            <el-button type="danger" :icon="Delete" link @click="onDelete(row.Id)"
              v-if="$store.state.loginUser?.IsAdmin">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { Delete } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { menpiao_shiduan_list, menpiao_shiduan_batchset, menpiao_shiduan_delete } from "@/http/api";
import { confirm_func } from "@/util/tFormat";

export default {
  props: { spId: Number, gzId: Number, tcId: Number },
  setup(props) {
    const state = reactive({
      tableData: [], beginDate: '', endDate: '',
      shiDuanMc: '', kssj: '', jzsj: '', batchKc: 0,
    });

    onMounted(() => { onLoad(); });

    const onLoad = () => {
      if (props.spId) {
        delete state.tableData;
        menpiao_shiduan_list(props.spId, null, props.gzId, props.tcId).then((res) => {
          if (res.status == 200) state.tableData = res.data;
        });
      }
    };

    const formatDate = (val) => {
      if (!val) return '';
      if (typeof val === 'string') return val.substring(0, 10);
      return val;
    };

    const formatTime = (val) => {
      if (!val) return '';
      if (typeof val === 'string') return val.substring(0, 5);
      return val;
    };

    const onBatchSet = () => {
      if (!state.beginDate || !state.endDate) {
        ElMessage.warning('请选择开始和结束日期');
        return;
      }
      if (!state.shiDuanMc || !state.kssj || !state.jzsj) {
        ElMessage.warning('请填写时段名称和时间');
        return;
      }
      if (state.batchKc <= 0) {
        ElMessage.warning('库存数必须大于0');
        return;
      }
      const items = [];
      let d = new Date(state.beginDate);
      const end = new Date(state.endDate);
      while (d <= end) {
        items.push({
          RiQi: formatDate(d),
          ShiDuanMc: state.shiDuanMc,
          Kssj: state.kssj + ':00',
          Jzsj: state.jzsj + ':00',
          Zkc: state.batchKc,
          GzId: props.gzId || 0,
          TcId: props.tcId || 0,
        });
        d.setDate(d.getDate() + 1);
      }
      menpiao_shiduan_batchset(props.spId, { Items: items }, props.gzId, props.tcId).then((res) => {
        if (res.status == 200) {
          ElMessage.success('库存设置成功');
          onLoad();
        }
      });
    };

    const onDelete = (id) => { confirm_func(menpiao_shiduan_delete, id, onLoad); };

    return { state, Delete, onLoad, formatDate, formatTime, onBatchSet, onDelete };
  },
};
</script>
<style scoped lang="less"></style>
